export const FEATURE_SWITCH_NAMES = {
  DISABLE_GIFT_CARD_PURCHASE: 'disableGiftCardPurchase',
};
export const BRAND_PAGE = 'Brand Page';
